import { render, staticRenderFns } from "./Domestic.vue?vue&type=template&id=0bb46c6a&scoped=true&"
import script from "./Domestic.vue?vue&type=script&lang=js&"
export * from "./Domestic.vue?vue&type=script&lang=js&"
import style0 from "./Domestic.vue?vue&type=style&index=0&id=0bb46c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bb46c6a",
  null
  
)

export default component.exports